export const formCache = {};

export const resetFormCache = (key) => {
  if (!key) {
    Object.keys(formCache).forEach((key) => delete formCache[key]);
  } else if (formCache[key]) {
    delete formCache[key];
  }
};
